import React, { useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import DroppableComDown from "../DroppableComDown.jsx";
import DroppableComUp from "../DroppableComUp.jsx";
import * as _ from "lodash";
import { isMobile } from "@/utils/common";
import {gradient} from "@/utils/colorCacl";

export default function Drag(props) {
  const [data, setData] = useState({});
  const [aa, update] = useState({});
  const [_colors, setcolors] = useState([])

  const { info = {}, answer = {}, changeAnswer } = props;
  const [selctListObj, setSelctListObj] = useState([]);

  console.log("answer", answer);
  useEffect(() => {
    props.info.childs.map((item) => {
      item.options1 = [];
    });
    setData(props.info);
  }, []);

  useEffect(() => {
    setcolors(gradient("#010000", "#dc2f20", data?.childs?.length || 1))
  }, [data])

  useEffect(() => {
    console.log("answer", answer);
    if (Object.keys(answer).length > 0) {
      const answerObj = answer[info.id];
      if (!answerObj) return;
      const qIds = Object.keys(answerObj);
      let historySelctListObj = [];
      data.childs.forEach((question) => {
        for (let i = 0; i < qIds.length; i++) {
          const qId = qIds[i];
          if (question.id === qId) {
            const oIds = Object.keys(answerObj[qId]);
            const options1 = question.options
              .filter((o) => oIds.includes(o.id))
              .map((o) => {
                o.dragShow = true;

                return o;
              });

            historySelctListObj.push(
              ...options1.map((itemc) => {
                return itemc.codeValue + "";
              })
            );
            question.options1 = options1;
          }
        }
      });
      setSelctListObj(historySelctListObj);
      setData(data);
    }
  }, [answer]);

  const arrMove = (array, first, second) => {
    var tmp = array[second];
    array[second] = array[first];
    array[first] = tmp;
    return array;
  };

  // 同一个区域托 j交换
  const sameDrag = (result) => {
    const { source, destination } = result;
    if (
      data.childIds.includes(destination.droppableId) &&
      data.childIds.includes(source.droppableId)
    ) {
      // sameDragDown(result);
    } else {
      data.options = arrMove(data.options, source.index, destination.index);
    }
  };
  // 是不是 航单选 1
  // 同一个区域  下面的
  const optionsDrag = (result) => {
    const { destination } = result;

    data.childs.forEach((item) => {
      if (item.id == destination.droppableId) {
        const obj3 = item.options.find(
          (item2) => item2.codeValue == result.draggableId
        );
        obj3.dragShow = true;
        let options1Itime = item.options1.find(
          (item) => obj3.codeValue == item.codeValue
        );
        if (!options1Itime) {
          item.options1.splice(destination.index, 0, obj3);
          let newSlcet = data.options.find(
            (item) => item.codeValue == result.draggableId
          );
          setSelctListObj((list) => {
            return [...list, newSlcet.codeValue + ""];
          });
        }
      }
    });
  };

  const childIdsDrag = (obj1, result) => {
    const { source, destination } = result;
    if (!obj1) {
      const obj3 = data.childs.find((item) => item.id == source.droppableId);
      if (
        data.childIds.includes(destination.droppableId) &&
        data.childIds.includes(source.droppableId)
      ) {
        let dragObj = obj3.options1[source.index];
        let findData = data.childs.find((item) => {
          return item.id === destination.droppableId;
        });
        let ishave = findData.options1.find(
          (item) => item.codeValue == dragObj.codeValue
        );
        if (!ishave) {
          let item_codeValue = obj3.options1.splice(source.index, 1);
          let findObk = findData.options.find(
            (item) => item.codeValue == item_codeValue[0].codeValue
          );
          findObk.dragShow = true;
          findData.options1.splice(destination.index, 0, findObk);
        }
      } else {
        const obj2 = obj3.options1[source.index];
        obj3.options1.splice(source.index, 1);
        selctListObj.splice(selctListObj.indexOf(obj2.codeValue), 1);
        setSelctListObj(selctListObj);
        // data.options.splice(destination.index, 0, obj2);
      }
    }
  };

  const commitData = (data1) => {
    const obj = {};
    data.childs.forEach((item1) => {
      item1.options1.forEach((item2) => {
        if (!obj[item1.id]) {
          obj[item1.id] = { [item2.id]: null };
        } else {
          obj[item1.id] = { ...obj[item1.id], [item2.id]: null };
        }
      });
    });

    changeAnswer(obj);
  };

  const onDragEnd = (result) => {
    // source移动   ==》 destination 目标
    const { source, destination } = result;
    if (!destination) {
      return;
    }
    //   options 作为选项
    if (source.droppableId === destination.droppableId) {
      sameDrag(result);
    } else {
      // 上面的区域 和新构建的数据 区域的数据块
      const obj1 = data.options.find(
        (item) => item.codeValue == result.draggableId
      );
      if (obj1) {
        optionsDrag(result);
      } else {
        childIdsDrag(obj1, result);
      }
    }
    commitData();
    // setData({ ...data });
  };

  const onBeforeCapture = () => {
    console.log("onBeforeCapture");
    /*...*/
  };

  const onBeforeDragStart = (ee) => {
    console.log("onBeforeDragStart", ee);
    sessionStorage.setItem("draggableId", ee.draggableId);
    /*...*/
  };

  const onDragStart = () => {
    console.log("onDragStart");

    /*...*/
  };
  const onDragUpdate = () => {
    console.log("onDragUpdate");
    /*...*/
  };

  const [eleWidth,setEleWidth] = useState(null);
  const [arrMaxLength,setArrMaxLength] = useState(1);
  const [itemMaxWidth,setItemMaxWidth] = useState("");
  const titleTbleInvisiable = (options,id) => {
    let _options = [];
    if (options) {
      _options = options.filter((item) => {
        return item.hide !== 1;
      });
    }
    return (
        <div id={`titleTbleReference-${id}`} style={{display: "flex", background: "#ccc",position:'absolute',width:eleWidth||"100px",visibility:'hidden'}}>
          {(_options || []).map((item1, index) => (
              <div
                  key={item1?.id}
                  style={{
                    border: "1px solid #ccc",
                    background: "rgb(204, 204, 204)",
                    borderRight: "1px solid #fff",
                    textAlign: "center",
                    flex:1
                  }}
              >
                <div dangerouslySetInnerHTML={{__html: imgSetStyle(item1?.description)}}></div>
                {/* 下面块区域 */}
              </div>
          ))}
        </div>
    );
  };
  const imgSetStyle=(htmlText)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    // 查找 <img> 标签并修改属性
    const img = doc.querySelector('img');
    if (img) {
      img.setAttribute('width','none')
      img.setAttribute('height','none')
      img.setAttribute('style', 'max-width: 100%;object-fit: contain;max-height:60px;height:100%'); // 修改样式
    }
    return doc.body.innerHTML
  }
  useEffect(()=>{
    if (!(info.preferences?.childPrefer?.optionForm === 6||info.preferences?.childPrefer?.optionForm ===5)){
      return
    }
    let ele=document.getElementById("titleTbleWidthReference")
    const observer = new ResizeObserver(() => {
      // 更新元素高度
      setEleWidth(ele.offsetWidth+'px');
    });

    // 开始观察元素
    observer.observe(ele);

    // 清理函数：在组件卸载时停止观察
    return () => {
      observer.disconnect();
    };


  },[])
  useEffect(()=>{
    let temparr = [data.childs];
    if (col && isMobile) {
      temparr = _.chunk(data.childs || [], +col);

    }
    setArrMaxLength(Math.max(...temparr.map(item=>(item||[]).length))||1)
  },[data.childs])
  useEffect(()=>{
    setItemMaxWidth((((((eleWidth?eleWidth.replace("px",""):100)||100)/(arrMaxLength||1))||100)-33)+'px')
    console.log("width:"+itemMaxWidth)
  },[eleWidth,arrMaxLength])

  const col = info.preferences?.optionPrefer?.optionsColumns;
  let arr = [data.childs];
  let _colorsIndex = 0
  let paishu=0
  if (col && isMobile) {
    arr = _.chunk(data.childs || [], +col);
  }

  return (
      <DragDropContext
          onDragEnd={onDragEnd}
          onBeforeCapture={onBeforeCapture}
          onBeforeDragStart={onBeforeDragStart}
          onDragStart={onDragStart}
          onDragUpdate={onDragUpdate}
          onDragEnd={onDragEnd}
      >
        {/* 上面拖拖动区域 */}
        <DroppableComUp
            direction={1}
            item1={data}
            update={update}
            selctListObj={selctListObj}
        />
        <div style={{width: '100%'}} id="titleTbleWidthReference"></div>
        {arr.map((data) => {
          paishu++;
          return (
              <>
              {(info.preferences?.childPrefer?.optionForm === 6||info.preferences?.childPrefer?.optionForm ===5)&&titleTbleInvisiable(data || [], paishu)}
              <div style={{display: 'flex', alignItems: 'stretch'}}>
                <div style={{flex: 1, display: 'flex', flexDirection: "column"}}>
                  <div style={{display: "flex", flex: 'auto'}}>
                    {/* 中间头信息移动至每个框上方以适应换行 */}
                    {(data || []).map((item1, index) => (
                        <div style={
                          {
                            flexWrap: "wrap",
                            flexDirection: "column",
                            flex: 1,
                            display: 'flex'
                          }
                        }>
                          <div
                              style={info.preferences?.childPrefer?.optionForm == 6 ? {backgroundImage: `linear-gradient(to right,${_colors[_colorsIndex]},${_colors[++_colorsIndex]})`,} : {display: 'none'}}>
                            &nbsp;
                          </div>
                          <DroppableComDown direction={1} item1={item1} style={{flex: 'auto'}}
                                            optionForm={info.preferences?.childPrefer?.optionForm}
                                            titleTbleData={data[index]} col={paishu}
                                            maxItemHeight={itemMaxWidth}
                          />
                        </div>
                    ))}
                  </div>
                </div>
              </div>
              </>
          );
        })}
      </DragDropContext>
  );
}
